export default function HouseholdChoresContent() {
  return (
    <>
      <h2>Why this template exists</h2>
      <p>
        Most chore charts pay kids for doing chores. This one flips it. Everyone
        starts the week with their allowance already in hand, and the job is to
        keep it. Skip a responsibility and a little comes off; pick up a bonus
        task and a little gets added. It turns the weekly nag into a game of
        protecting what is already yours.
      </p>

      <h2>How the board is set up</h2>
      <p>
        Each person gets a column, with their weekly allowance written right in
        the column name. Cards are the responsibilities, and the dollar value
        rides on the card, so everyone can see exactly what a missed task costs.
        The Bonus Pool holds extra jobs anyone can drag into their own column to
        earn a little more. There is a column for the grown-ups too, because
        accountability that only points one direction is not really
        accountability.
      </p>

      <h2>Running the week</h2>
      <p>
        At the start of the week, heart the cards you expect to see done. If
        something gets skipped, un-heart it, and that is the signal it will come
        off the next payout. Add a poll to a card when you want more than done or
        missed, for example an "exceeded expectations" option, and the results
        aggregate over time so you can see who is consistently strong at what.
      </p>

      <h2>Payout and reset</h2>
      <p>
        At the end of the week, go column by column: un-hearted responsibilities
        come off the allowance, completed bonus tasks get added on. Pin the cards
        you want to keep, then clone the board to roll into a fresh week with the
        columns intact and the polls reset.
      </p>

      <h2>Best for</h2>
      <p>
        Families running weekly chores and allowances for kids, roommates
        splitting shared tasks, or anyone who wants a visible, fair record of who
        did what. For the full story behind this template, read{" "}
        <a href="/blog/2026-08-08-household-chores">
          how Retroboard became a household allowance system
        </a>
        .
      </p>
    </>
  )
}
